<template>
  <div class="" id="CentralCommittee">
    <Preloader v-if="!loaded" />
    <div class="container-fluid">
      <div class="row pt-2">
        <div class="col-12 ps-2 pe-2">
          <h3 class="bg-secondary rounded p-1 ps-2 text-white text-start" style="font-family: Rockwell">Central Committee</h3>
        </div>
        <div class="col-md-6 ps-2 pe-2" v-for="(member,key) in members" :key="key">
          <div class="card mb-3 member-bg">
            <div class="row g-0">
              <div class="col-md-4 bg-white p-1">
                <img :src="member.photo" class="member-img img-fluid rounded-start" alt="Image">
              </div>
              <div class="col-md-8 text-start">
                <div class="card-body" style="font-family: Rockwell">
                  <h5 class="card-title fw-bold">{{member.name}}</h5>
                  <h6 class="card-title fw-bold">{{member.title}}</h6>
                  <div class="description m-0 p-0" v-html="member.description"></div>
<!--                  <p class="card-text mb-0" v-html="member.description"></p>-->
<!--                  <p class="card-text">{{member.department}} <br> {{member.institute}}</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Preloader from "../components/Preloader";
  export default {
    name: "CentralCommittee",
    components: {Preloader},
    data (){
      return {
        members:[],
        loaded:false
      }
    },
    created() {
      this.$http.get("get-central-members").then(function (response) {this.members = response.body; this.loaded = true;});
    }
  }
</script>

<style scoped>
  .member-bg{
    background-color: #edfff6;
  }
  .member-img{
    width: 200px !important;
    height: 200px !important;
  }
</style>